<template>
    <!-- Botón para volver atrás con un icono de flecha -->
    <button @click="goBack" class="back-button">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <!-- Icono de flecha hacia la izquierda -->
            <path d="M19 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H19v-2z" />
        </svg>
    </button>
</template>

<script>
export default {
    methods: {
        // Método para navegar a la página anterior
        goBack() {
            this.$router.go(-1); // Navega a la página anterior
        },
    },
};
</script>

<style scoped>
/* Estilos para el botón de volver atrás */
.back-button {
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    padding: 1px;
    height: 30px;
    margin-right: 0.5rem;
    background-color: transparent;
}

/* Color del icono en estado normal */
.back-button svg {
    fill: #2f3e4a; /* Color del icono */
}

/* Color del icono al pasar el ratón por encima */
.back-button:hover svg {
    fill: #f93f6e; /* Color del icono al pasar el ratón */
}
</style>
